import React from 'react'

interface IconProps {
  color?: string
  size?: number
}

export const Unlock: React.FC<IconProps> = ({ color = '#fff', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 8.5H20C20.5523 8.5 21 8.94772 21 9.5V21.5C21 22.0523 20.5523 22.5 20 22.5H4C3.44772 22.5 3 22.0523 3 21.5V9.5C3 8.94772 3.44772 8.5 4 8.5H6V7.5C6 4.18629 8.68629 1.5 12 1.5C14.0683 1.5 15.8922 2.54657 16.971 4.13903C17.1607 4.41904 17.0406 4.79231 16.738 4.94347L16.0997 5.2624C15.7644 5.42992 15.3612 5.29862 15.1273 5.00573C14.3943 4.08799 13.2658 3.5 12 3.5C9.79086 3.5 8 5.29086 8 7.5V8.5H16H18ZM11 18.5V16.2324C10.4022 15.8866 10 15.2403 10 14.5C10 13.3954 10.8954 12.5 12 12.5C13.1046 12.5 14 13.3954 14 14.5C14 15.2403 13.5978 15.8866 13 16.2324V18.5H11Z"
      fill={color}
    />
  </svg>
)
